module.exports = __webpack_public_path__ + "static/img/bg-index.26fd4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyao/bg-index.jpg
// module id = Jpp/
// module chunks = 1